import React from 'react';
import { Alert, AlertTitle, Button, Stack, Typography } from '@mui/material';
import { ErrorOutline, Refresh } from '@mui/icons-material';

interface NetworkErrorAlertProps {
  message?: string;
  onRetry?: () => void;
}

/**
 * Alert component shown when a network error occurs
 */
const NetworkErrorAlert: React.FC<NetworkErrorAlertProps> = ({
  message = 'Unable to connect to the server. Please check your internet connection.',
  onRetry
}) => {
  return (
    <Alert
      severity="error"
      icon={<ErrorOutline fontSize="inherit" />}
      sx={{ mb: 2, alignItems: 'center' }}
    >
      <AlertTitle>Network Error</AlertTitle>
      <Stack 
        direction={{ xs: 'column', sm: 'row' }} 
        spacing={2} 
        alignItems={{ xs: 'start', sm: 'center' }}
      >
        <Typography variant="body2">{message}</Typography>
        {onRetry && (
          <Button
            size="small"
            color="error"
            variant="outlined"
            startIcon={<Refresh />}
            onClick={onRetry}
            sx={{ ml: { xs: 0, sm: 2 } }}
          >
            Retry
          </Button>
        )}
      </Stack>
    </Alert>
  );
};

export default NetworkErrorAlert;

